/**
 * PostHog provider — the only feature-flag source. On-prem, where PostHog
 * never initializes, no flags arrive and everything falls back to `false`
 * (browser overrides still work — the store applies those on top).
 *
 * @see ../providers.js for the provider contract.
 */
import { onPosthogFeatureFlags, setPosthogFlagContext } from '../../posthog'

export const createPosthogProvider = ({ onFlags } = {}) => {
  let unsubscribe = null

  const setIdentity = (identity) =>
    setPosthogFlagContext({
      companyId: identity?.companyId,
      environment: identity?.environment,
      region: identity?.region,
    })

  return {
    name: 'posthog',

    start(identity) {
      onFlags({})
      if (identity) setIdentity(identity)
      try {
        unsubscribe = onPosthogFeatureFlags((_flags, variants) => onFlags(variants || {}))
      } catch {} // eslint-disable-line no-empty
    },

    setIdentity,

    stop() {
      try {
        unsubscribe?.()
      } catch {} // eslint-disable-line no-empty
    },
  }
}
